import type { Dispatcher } from '../dispatcher.js';
import { serializeSession } from '../serializer.js';
import type { Project } from '../serializer.types.js';
import { getStudioContext } from './store.js';

export interface SessionStateResult {
  project: Project;
}

// Real binding into openDAW's project state. When a studio context is
// attached, `serializeSession` translates the live `Project` snapshot into
// the canonical §5.1 shape. When no studio is attached we still return a
// valid empty-but-conformant project so the agent's tool schemas validate.
async function getSessionState(): Promise<SessionStateResult> {
  const ctx = getStudioContext();
  if (ctx === null) {
    return { project: serializeSession(null) };
  }
  return { project: serializeSession(ctx.getProject()) };
}

export const sessionHandlers = { getSessionState } as const;

export function registerSessionHandlers(d: Dispatcher): void {
  d.register('getSessionState', getSessionState);
}
